import { useEffect } from "react";
import { useLenis } from "../hooks/useLenis";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Constat } from "../components/site/Constat";
import { Manifeste } from "../components/site/Manifeste";
import { Parentheses } from "../components/site/Parentheses";
import { MapParentheses } from "../components/site/MapParentheses";
import { Process } from "../components/site/Process";
import { PourQui } from "../components/site/PourQui";
import { DemandeBon } from "../components/site/DemandeBon";
import { Testimonials } from "../components/site/Testimonials";
import { Reseau } from "../components/site/Reseau";
import { Contact } from "../components/site/Contact";

export default function LandingPage() {
  useLenis();

  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, []);

  return (
    <div data-testid="landing-page" className="relative bg-pblv-bg">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Constat />
        <Manifeste />
        <Parentheses />
        <MapParentheses />
        <Process />
        <PourQui />
        <DemandeBon />
        <Testimonials />
        <Reseau />
      </main>
      <Contact />
    </div>
  );
}
